/**
 * Remove HTML tags from an HTML string
 * @param {String} html - Some HTML string
 * @return {String} the text within the HTML.
 */
export const stripHTMLTags = (html) => {
	if (html.indexOf("<script>") !== -1) {
		return html.replace(/<\/?[^>]+(>|$)/g, "");
	}
	let div = document.createElement("div");
	div.innerHTML = html;
	return div.textContent;
};

/**
 * Given an HTMLElement with a CSS `background-image` it preloads the higher
 * resolution version of this bg image and replaces it when it finishes loading
 * @param {HTMLElement} el - An HTMLElement with a `background-image`
 */
export const replaceLoResImage = (el) => {
	const style = el.currentStyle || window.getComputedStyle(el, false);

	const loResImageUri = style.backgroundImage.replace(
		/(^url\(|\)|"|')/gi,
		""
	);

	const hiResImageUri = loResImageUri.replace("-min", "");

	if (loResImageUri.indexOf("-min") !== -1) {
		let loResImage = new Image();
		loResImage.onload = () => {
			let hiResImage = new Image();
			hiResImage.onload = () => {
				el.style.backgroundImage = `url(${hiResImageUri})`;
			};
			hiResImage.src = hiResImageUri;
		};
		loResImage.src = loResImageUri;
	}
};

/**
 * Write the CCPA Privacy string into a cookie to be read by the API.
 * @param {string} value The value of the cookie to be written. Defaults to 1--- as per understood specs.
 */
export function writeCCPACookie(value = "1---") {
	let d = new Date();
	d.setTime(d.getTime() + 10 * 365 * 24 * 60 * 60 * 1000); // Make it roughly 10 years from now.
	const expires = "expires=" + d.toUTCString();
	document.cookie = `usprivacy=${value};${expires};path=/;Domain=.yourdictionary.com;SameSite=Lax;secure`;
}

/**
 * Read the CCPA Privacy string from the 'usprivacy' cookie.
 */
export function readCCPACookie() {
	var cookieValue = "";
	var cookieName = "usprivacy=";
	var cookieArray = document.cookie.split(";");
	for (var i = 0; i < cookieArray.length; i++) {
		var cookie = cookieArray[i];
		while (cookie.charAt(0) == " ") {
			cookie = cookie.substring(1);
		}
		if (cookie.indexOf(cookieName) == 0) {
			cookieValue = cookie.substring(cookieName.length, cookie.length);
			break;
		}
	}

	// If the cookie cannot be found or has an invalid value, default it back to 1---, the CCPA default privacy string value.
	if (!/^[1][nNyY-][nNyY-][nNyY-]$/.test(cookieValue)) {
		cookieValue = "1---";
	}

	return cookieValue;
}
